import Vue from 'vue';

export default {
	async register(details) {
		const response = await Vue.axios.post('/account', details)
			.catch((e) => {
				throw e.response.data;
			});
		return response.data;
	},
	async update(details) {
		if(!details) return;
		const response = await Vue.axios.put('/account', details, {
			headers: { Authorization: `Bearer ${Vue.store.state.auth.token}` },
		});
		return response.data;
	},
	async login(credentials) {
		const response = await Vue.axios.post('/login', {
			email: credentials.email,
			password: credentials.password,
		});
		return response.data;
	},
	async loginByToken() {
		const response = await Vue.axios.get('/token', {
			headers: { Authorization: `Bearer ${Vue.store.state.auth.token}` },
		});
		return response.data;
	},
	async sendSupportMessage(message) {
		const response = await Vue.axios.post('/support/mail', message, {
			headers: { Authorization: `Bearer ${Vue.store.state.auth.token}` },
		});
		return response.data;
	},
};
